import { render, staticRenderFns } from "./NursingTaskTimeout.vue?vue&type=template&id=7c970398"
import script from "./NursingTaskTimeout.vue?vue&type=script&lang=js"
export * from "./NursingTaskTimeout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports